"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_web_components_1 = require("@nimles/react-web-components");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var Element_1 = require("./Element");

var Link_1 = require("./Link");

var StyledFooter = styled_1.default.footer(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 20px;\n  color: #fff;\n  background-color: #0f2d4c;\n  min-height: 20vh;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n"], ["\n  padding-top: 20px;\n  color: #fff;\n  background-color: #0f2d4c;\n  min-height: 20vh;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.footer.boxShadow;
}, function (_a) {
  var theme = _a.theme,
      backgroundColor = _a.backgroundColor;
  return backgroundColor || theme.footer.background;
}, function (_a) {
  var theme = _a.theme,
      color = _a.color;
  return color || theme.footer.color;
});
var Name = styled_1.default.h3(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #fff;\n"], ["\n  color: #fff;\n"])));
var FieldIcon = styled_1.default(react_fontawesome_1.FontAwesomeIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  margin-right: 10px;\n"], ["\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  margin-right: 10px;\n"])));
var Field = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  margin-bottom: 10px;\n"], ["\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  margin-bottom: 10px;\n"])));
var FooterList = styled_1.default.ul(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n  margin-top: 0;\n"], ["\n  list-style: none;\n  padding: 0;\n  margin-top: 0;\n"])));
var FooterListItem = styled_1.default.li(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var FooterLink = styled_1.default(Link_1.NavLink)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: #fff;\n"], ["\n  color: #fff;\n"])));

exports.Footer = function (_a) {
  var children = _a.children,
      layoutId = _a.layoutId,
      color = _a.color,
      backgroundColor = _a.backgroundColor;
  var tenant = react_redux_1.useSelector(function (_a) {
    var publicTenants = _a.publicTenants;
    return publicTenants.selected;
  });
  var organization = react_redux_1.useSelector(function (_a) {
    var publicOrganizations = _a.publicOrganizations;
    return publicOrganizations.selected;
  });
  var pages = react_redux_1.useSelector(function (_a) {
    var publicPages = _a.publicPages;
    return publicPages.values;
  });
  var posts = react_redux_1.useSelector(function (_a) {
    var publicPosts = _a.publicPosts;
    return publicPosts.values;
  });
  var layouts = react_redux_1.useSelector(function (_a) {
    var publicLayouts = _a.publicLayouts;
    return publicLayouts.values;
  });
  var layout = layouts && (layoutId && layouts.find(function (l) {
    return l.id === layoutId;
  }) || layouts.find(function (l) {
    return l.layoutType === 'Footer';
  }));
  var name = organization ? organization.name : tenant && tenant.name;
  var email = organization ? organization.email : tenant && tenant.email;
  var phoneNumber = organization ? organization.phoneNumber : tenant && tenant.phoneNumber;
  var addressStreet = organization ? organization.address && organization.address.street : tenant && tenant.address && tenant.address.street;
  var addressPostalCode = organization ? organization.address && organization.address.postalCode : tenant && tenant.address && tenant.address.postalCode;
  var addressCity = organization ? organization.city && organization.address.city : tenant && tenant.address && tenant.address.city;
  var addressCountry = organization ? organization.address && organization.address.country : tenant && tenant.address && tenant.address.country;
  return react_1.default.createElement(StyledFooter, {
    color: color,
    backgroundColor: backgroundColor
  }, layout ? layout.elements && layout.elements.map(function (element) {
    return react_1.default.createElement(Element_1.Element, {
      tenant: tenant,
      element: element,
      root: "Footer"
    });
  }) : children || react_1.default.createElement(react_web_components_1.Container, {
    padding: true
  }, react_1.default.createElement(react_web_components_1.Row, {
    wrap: true,
    justify: "space-between"
  }, react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(Name, null, name), phoneNumber && react_1.default.createElement(Field, null, react_1.default.createElement(FieldIcon, {
    icon: free_solid_svg_icons_1.faPhone
  }), phoneNumber), email && react_1.default.createElement(Field, null, react_1.default.createElement(FieldIcon, {
    icon: free_solid_svg_icons_1.faEnvelope
  }), email), addressStreet && react_1.default.createElement(Field, null, react_1.default.createElement(FieldIcon, {
    icon: free_solid_svg_icons_1.faCity
  }), react_1.default.createElement("span", null, react_1.default.createElement("p", null, addressStreet), react_1.default.createElement("p", null, addressPostalCode, " ", addressCity), react_1.default.createElement("p", null, addressCountry)))), react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(Name, null, "Links"), react_1.default.createElement(FooterList, null, pages.filter(function (page) {
    return page.uniqueName;
  }).map(function (page) {
    return react_1.default.createElement(FooterListItem, null, react_1.default.createElement(FooterLink, {
      to: "/" + page.uniqueName + "/pg"
    }, page.title));
  }))), react_1.default.createElement(react_web_components_1.Column, null, react_1.default.createElement(Name, null, react_1.default.createElement(FooterLink, {
    to: "/blog"
  }, "Blog")), react_1.default.createElement(FooterList, null, posts.filter(function (post) {
    return post.uniqueName;
  }).map(function (post) {
    return react_1.default.createElement(FooterListItem, null, react_1.default.createElement(FooterLink, {
      to: "/" + post.uniqueName + "/pt"
    }, post.title));
  }))))));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;